/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_From_UrlInputs */



/**
* | output |
* | --- |
* | "From URL" |
*
* @param {Deck_Upload_From_UrlInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_from_url = /** @type {((inputs?: Deck_Upload_From_UrlInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_From_UrlInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Depuis une URL")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desde URL")
	if (locale === "pt") return /** @type {LocalizedString} */ ("De URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("Da URL")
	return /** @type {LocalizedString} */ ("From URL")
});